/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Field } from './Field.js';
import {
    FieldFromJSON,
    FieldFromJSONTyped,
    FieldToJSON,
} from './Field.js';

/**
 * 
 * @export
 * @interface FieldsResponse
 */
export interface FieldsResponse {
    /**
     * 
     * @type {Array<Field>}
     * @memberof FieldsResponse
     */
    data?: Array<Field>;
    /**
     * 
     * @type {number}
     * @memberof FieldsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof FieldsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof FieldsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof FieldsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the FieldsResponse interface.
 */
export function instanceOfFieldsResponse(value: object): boolean {
    return true;
}

export function FieldsResponseFromJSON(json: any): FieldsResponse {
    return FieldsResponseFromJSONTyped(json, false);
}

export function FieldsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(FieldFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function FieldsResponseToJSON(value?: FieldsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(FieldToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

